import React, { useEffect, useState } from "react";
import { Container } from "../../../components";
import { Text, Heading, Select } from "@telia/teddy";
import _size from "lodash/size";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../../../../models";
import { PhoneNumberFormatters } from "../../../app/utils";
import RenderVerification from "../../../checkout/components/organisms/Verification/RenderVerification";
import { sendCodeEsim, verifyCodeEsim } from "../../../checkout/state/actions/esimActions";
import { getAdminPhoneNumbers } from "../../state/selectors";
import TEXT from "../../text-consts";
import "./PhoneNumberCheck.less";

interface StateProps {
    adminPhoneNumbers: string[];
}

type ConfirmNumberProps = StateProps;

const PhoneNumberCheck: React.FC<ConfirmNumberProps> = ({ adminPhoneNumbers }) => {
    const dispatch = useDispatch();
    const [selectedPhoneNumber, setSelectedPhoneNumber] = useState(adminPhoneNumbers[0]);

    useEffect(() => {
        if (_size(adminPhoneNumbers) > 0) {
            setSelectedPhoneNumber(adminPhoneNumbers[0]);
        }
    }, []);

    return (
        <Container size="medium" noMargin>
            <Heading mb="100" as="h2" variant="title-200">
                {TEXT.CONFIRM_NUMBER.HEADING}
            </Heading>
            <div className="phone-number-check__margin-bottom">
                <Text mb="100">{TEXT.CONFIRM_NUMBER.DESCRIPTION}</Text>
            </div>
            <div className="phone-number-check__margin-bottom">
                <Select
                    name="admin-phone-number"
                    label={TEXT.CONFIRM_NUMBER.NUMBER_FIELD.LABEL_TEXT}
                    options={adminPhoneNumbers}
                    value={(selectedPhoneNumber || "").replace(/\s/g, "")}
                    onValueChange={(value) => {
                        setSelectedPhoneNumber(value);
                        return value;
                    }}
                    className="phone-number-check__select"
                >
                    <Select.Trigger data-di-mask className="phone-number-check__select-trigger">
                        <Select.Value />
                    </Select.Trigger>
                    <Select.Content>
                        <Select.Viewport>
                            {adminPhoneNumbers.map((number) => (
                                <Select.Item key={number} value={number}>
                                    {PhoneNumberFormatters[0].displayFn(number)}
                                </Select.Item>
                            ))}
                        </Select.Viewport>
                    </Select.Content>
                </Select>
                <RenderVerification
                    selectedPhoneNumber={selectedPhoneNumber}
                    sendCode={async (...args): Promise<void> => dispatch(sendCodeEsim(...args))}
                    verifyCode={async (...args): Promise<void> => dispatch(verifyCodeEsim(...args))}
                />
            </div>
        </Container>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    adminPhoneNumbers: getAdminPhoneNumbers(state),
});

export default connect(mapStateToProps)(PhoneNumberCheck);
